import React from 'react';
import { View, StyleSheet, Text} from 'react-native';
import { IconButton, TextInput } from 'react-native-paper';
interface TextFieldProps {
  field: any;
  control: any;
  editable: boolean;
  styles: any;
  Ctrl: any;
  errors:any;
  logTitle?:any;
  userTypedLocation?:any;
}
const styles = StyleSheet.create({
  TextField: {
    borderWidth: 0.5, // Set the border width
    borderColor: 'gray', // Set the border color
    borderRadius: 5, // Set the border radius (optional)

    shadowColor: 'black', // Set the shadow color
    shadowOffset: { width: 0, height: 2 }, // Set the shadow offset
    shadowOpacity: 0.5, // Set the shadow opacity
    shadowRadius: 4, // Set the shadow radius
    elevation: 4
  }
})
const LocationField: React.FC<TextFieldProps> = ({ field, control, editable, styles, Ctrl, errors, logTitle, userTypedLocation }) => {
  const rule = field.required ? { required: field.label + ' is required' } : { required: false};
 function ChangeEvent(val:string)
 {
  userTypedLocation(val);
 }
  return (
    <View>
      <View style={{width:'100%'}}><Text style={{fontWeight:'bold', fontSize:16}}>{field.label}</Text></View>
      
      {editable === false ? <View><Text style={{fontWeight:'normal', fontSize:12}}>{field.defaultValue ?? null}</Text></View> :
      <Ctrl
        key={field.key}
        control={control}
        //rules={rule}
        name={field.key}
        defaultValue={field.defaultValue && field.defaultValue}
        render={({ field: { onChange, onBlur, value } }: { field: { onChange: any, onBlur: any, value: any } }) => (
          <TextInput
            label={null}
            value={value}
            onChangeText={(val)=>{ChangeEvent(val)}}
            style={styles}
            editable={editable}
            disabled={!editable}
            onBlur={onBlur}
            multiline={field.multiline ? true : false}
            outlineStyle={styles}
          />
        )}
      />
        }
        {errors[field.key]?.message && <Text style={{ color: 'red' }}>{errors[field.key]?.message}</Text>}
    </View>
  );
};

export default LocationField;